import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/landing/primitives";
import { LiveFlowCells } from "./LiveFlowCells";

export const FLOW_CELLS_URL = "https://alpha.tradrquant.com/flow-cells";
export const FLOW_CELLS_PAGE = "/flow-cells-whale-rotation-map";

export const FlowCellsBand = () => (
  <section data-testid="flow-cells-band" aria-labelledby="flow-cells-title" className="border-b border-white/[0.06] bg-[#0A0B0D]">
    <Reveal className="mx-auto max-w-[1400px] px-6 py-12 md:px-12 md:py-14">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#5A6170]"><span className="text-[#FFB224]">New</span> · Flow Cells · free</p>
          <h2 id="flow-cells-title" className="mt-2 font-display text-2xl font-semibold tracking-[-0.03em] text-[#ECEBE4] md:text-3xl">
            Every coin. Every whale. <span className="text-[#7D8390]">One living map.</span>
          </h2>
          <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-[#9DA3AE]">
            A live crypto heatmap where each cell is a market: size shows volume, glow shows how hard it moved, and the bar shows which way tracked Hyperliquid whales lean. Watch whale money rotate between coins in real time.
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
          <a href={FLOW_CELLS_URL} data-testid="flow-cells-open" className="group inline-flex items-center justify-center gap-2 bg-[#BACD1C] px-6 py-3.5 font-mono text-[12px] uppercase tracking-[0.14em] text-black transition-colors duration-300 hover:bg-[#ECEBE4]">
            Open Flow Cells <ArrowUpRight size={15} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <Link to={FLOW_CELLS_PAGE} data-testid="flow-cells-learn" className="group inline-flex items-center justify-center gap-2 px-3 py-3 font-mono text-[11px] uppercase tracking-[0.16em] text-[#9DA3AE] transition-colors hover:text-[#ECEBE4]">
            How to read it <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
      <div className="mt-8"><LiveFlowCells /></div>
    </Reveal>
  </section>
);
